// extracted by mini-css-extract-plugin
export default {"TableHeader":"TableData_TableHeader__L6I+E","button":"TableData_button__H8K4Z","TableSearch":"TableData_TableSearch__FNqmf"};